import request from '@/service/request';

export const getPoliciesList = (data: any) => {
  return request(`/v1/agency-platform-vn-v2/agency/policies`, { params: data });
};

export const getQuotesList = (data: any) => {
  return request(`/v1/agency-platform-vn-v2/agency/quotes`, { params: data });
};

export const getPoliciesDetail = (data: any) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/policies/:id`.replace(':id', data.id),
  );
};

export const getQuoteDetail = (data: any) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/quotes/:quote_id`.replace(
      ':quote_id',
      data.id,
    ),
  );
};

export const getPolicyDetailConfig = (data: any) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${data.product_type}/products/${data.product_key}/plans/${data.plan_key}/application_config`,
  );
};
